import { createSlice } from '@reduxjs/toolkit';

import { ICompareState } from '../../types/compare';

const initialState: ICompareState = {
  isAdded: false,
};

export const compareSlice = createSlice({
  name: 'compare',
  initialState,
  reducers: {
    toggleCompare: state => {
      state.isAdded = !state.isAdded;
    },
  },
});

export const {
  reducer: compareReducer,
  actions: { toggleCompare },
} = compareSlice;
